/**
 * 统一格式化待审批/待审核责任人提示。
 *
 * @param {Object|null} info 后端 pendingApproval 结构
 * @returns {string} 可直接展示给用户的中文摘要
 */
export function formatPendingApproval(info) {
  if (!info) return ''
  const roles = Array.from(new Set((info.responsibleRoleNames || []).filter(Boolean)))
  const roleText = roles.length ? roles.join('/') : '待配置角色'
  const actionName = info.actionType === 'REVIEW' ? '审核' : '审批'
  const approvers = (info.approvers || []).filter(item => item && item.displayName).slice(0, 3)
  if (!approvers.length || Number(info.totalApproverCount || 0) <= 0) {
    return `责任角色：${roleText}；当前未配置可处理账号，请联系超级管理员配置。`
  }
  const approverRoleCount = new Set(approvers.map(item => item.roleName).filter(Boolean)).size
  const names = approvers.map(item => {
    if (approverRoleCount > 1 && item.roleName) {
      return `${item.displayName}（${item.roleName}）`
    }
    return item.displayName
  }).join('/')
  const total = Number(info.totalApproverCount || approvers.length)
  const suffix = total > approvers.length ? `等，共 ${total} 人` : `，共 ${total} 人`
  return `责任角色：${roleText}；可${actionName}人：${names}${suffix}`
}

/** 将责任人摘要追加到普通说明文本，确保无需悬停也能看到。 */
export function appendPendingApproval(text, info) {
  const summary = formatPendingApproval(info)
  if (!summary) return text || ''
  return text ? `${text}；${summary}` : summary
}
